import { View, Text } from "@react-pdf/renderer";
import styles from "./styles";
import FaNum from "./FaNum";

export default function InvoiceTotals({ paid }) {
  return (
    <View style={styles.summaryTotal}>
      <Text style={styles.extraRowTitleEnd}>مبلغ قابل پرداخت</Text>

      <View style={styles.priceRow}>
        <Text style={styles.priceFaNum}>
          <FaNum>{paid}</FaNum>
        </Text>
        <Text style={styles.toman}>تومان</Text>
      </View>
    </View>
  );
}
